import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Click links below to go to the status page.
        </p>
        <a
          className="App-link"
          href="https://status.mjclouds.com/status/app"
          target="_blank"
          rel="noopener noreferrer"
        >
          Application
        </a>
        <a
          className="App-link"
          href="https://status.mjclouds.com/status/mjclouds"
          target="_blank"
          rel="noopener noreferrer"
        >
          Supplier: MJClouds
        </a>
      </header>
    </div>
  );
}

export default App;
